import React from 'react'

const SvgFemale = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 3a6 6 0 011 11.915V16.5h2.5a1 1 0 110 2H13V21a1 1 0 11-2 0v-2.5H8.5a1 1 0 110-2H11v-1.585A6 6 0 0112 3zm0 2a4 4 0 100 8 4 4 0 000-8z'
    />
  </svg>
)

export default SvgFemale
